<div class="array-tooltip-display-wrap">
  <ng-container><span class="first-item" [class.has-tip]="items.length > showAmount">{{display | display}}</span></ng-container>
  @if (items.length > showAmount) {
    <span (click)="$event.preventDefault();$event.stopPropagation();" class="amount" placement="top" [autoClose]="false" tabindex="0" triggers="hover focus" [ngbTooltip]="tip" [openDelay]="100" [closeDelay]="200">+{{items.length - showAmount}}</span>
  }
</div>